// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__fliw+","bold":"Skills_bold__p3KsM"};